export default __webpack_public_path__ + "static/media/stats2Venus.fcbfbe11.wav";